import "../../organisms/appointment/appointment.scss";

import React from "react";

const DropdownComponent = ({
  title,
  optionsList,
  chosenOption,
  handleOptionSelect,
  isDropdownOpen,
  handleDropdownToggle,
  disabledCondition,
  secondTitle,
}) => {
  return (
    <div className="o-appointment__places">
      <span className="o-appointment__title">{title}</span>
      <div
        className={`o-appointment__place_option ${
          isDropdownOpen ? "open" : ""
        } ${disabledCondition ? "" : "disabledInput"}`}
        onClick={handleDropdownToggle}
        data-testid="dropdown-container"
      >
        <div className="o-appointment__selected_option">
          {chosenOption
            ? optionsList?.find((option) => option.id === chosenOption)
                ?.maskName
            : `${secondTitle}`}
        </div>
        <div className="o-appointment__dropdown_icon">&#9660;</div>
        {disabledCondition && isDropdownOpen ? (
          <div className="o-appointment__dropdown">
            {optionsList?.map((option) => (
              <div
                key={option.id}
                className="o-appointment__dropdown_option"
                onClick={() => handleOptionSelect(option.id)}
              >
                {option.maskName}
              </div>
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default DropdownComponent;
